import { RateCardDetail } from "./rateCardDetail.model";

export class RateCard {
  id: Number = null;
  isDefault: Boolean;
  rateCardDetails: Array<RateCardDetail>;
}
